import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { apps } from '../data/apps';

const billedApps = apps.filter((app) => app.webBilling);

// 本网站（spiegeleistudio.com）的隐私政策；各 App 的隐私政策另外链接
const Privacy: React.FC = () => {
  return (
    <LegalLayout title="Privacy Policy" lastUpdated="October 24, 2026">
      <p>
        This policy explains what happens to your data when you visit spiegeleistudio.com. Each of our apps has its
        own privacy policy, which covers the app and its website:
      </p>
      <ul>
        {billedApps.map((app) => (
          <li key={app.id}>
            {app.title}: <a href={app.webBilling!.privacyUrl}>Privacy Policy</a>
          </li>
        ))}
        <li>
          DracoChess: <a href="/dracochess/privacy">Privacy Policy</a>
        </li>
      </ul>

      <h2>Who is responsible</h2>
      <p>
        Spiegelei Studio (Inh. Bing Xia), Hedwig-Wachenheim-Karree 142, 51107 Cologne, Germany.
        <br />
        Email: <a href="mailto:service@spiegeleistudio.com">service@spiegeleistudio.com</a>
      </p>

      <h2>Visiting this website</h2>
      <p>
        This website is hosted by Netlify. When you open a page, the server processes technical data that your
        browser sends, such as your IP address, the page you requested, the time, and your browser type, in order
        to deliver the page and keep the service secure (Art. 6(1)(f) GDPR). This website sets no cookies of its own
        and uses no analytics, advertising, or tracking tools.
      </p>

      <h2>Payments</h2>
      <p>
        Purchases on the websites of our apps are processed by Paddle.com, our reseller and Merchant of Record.
        The page spiegeleistudio.com/checkout opens Paddle’s checkout for payment links sent by Paddle, for example
        to update a payment method. Paddle processes your payment and billing details under its own{' '}
        <a href="https://www.paddle.com/legal/privacy" target="_blank" rel="noopener noreferrer">privacy policy</a>{' '}
        and may set its own cookies. We never receive your card or bank details.
      </p>

      <h2>Contacting us</h2>
      <p>
        If you email us, we use your message and email address to answer you (Art. 6(1)(b) or (f) GDPR) and delete
        them when they are no longer needed.
      </p>

      <h2>Your rights</h2>
      <p>
        You have the right to access, correct, and delete your data, to restrict or object to its processing, and to
        data portability. To use these rights, write to us. You can also complain to a data protection authority,
        for example the one in North Rhine-Westphalia, Germany.
      </p>
    </LegalLayout>
  );
};

export default Privacy;
